import * as React from 'react';
import { DefaultLayout } from '../../../components/DefaultLayout';
import { Seo } from "../../../components/Seo";

import { YandexMetrika } from '../../../components/YandexMetrika';
import { MailRu } from '../../../components/MailRu';
import { TikTok } from '../../../components/TikTok';
import { VKPixel } from '../../../components/VKPixel';
import { AdvCake } from '../../../components/AdvCake';

import {
  Screen1,
  ProblemsWithVideo,
  Results,
  ResultsAndReviewsTop,
  Tasks,
  HowWorks,
  BlocksCourseStructure,
  AboutPeople,
  AboutAdvance,
  Founder,
  Cost,
  main
} from "../../../components/LandingTemplates/uchis_uchitsya";

import { GetCourseWidget } from "../../../components/GetCourseWidget";
import { VideoReviewsSimple } from "../../../components/VideoReviewsSimple";
import { FooterMedium } from "../../../components/FooterMedium";

import { blocksDataKids } from "../../../components/LandingTemplates/uchis_uchitsya/data/blocksDataKids";
import resultsAndReviewsKids from "../../../components/LandingTemplates/uchis_uchitsya/data/resultsAndReviewsKids.json";
import methodistsData from "../../../components/LandingTemplates/uchis_uchitsya/data/methodistsDataNew.json";
import videoReviews from "../../../components/LandingTemplates/uchis_uchitsya/data/videoReviewsSimpleKids.json";

const TITLE = 'Онлайн-курс «Учись Учиться» - когнитивное развитие ребенка';
const DESCRIPTION = 'Развитие когнитивных навыков у детей 5-7 классов. Курс повышает эффективность обучения и мотивацию учиться, помогает развить навыки и качества, важные для успеха в будущем.';
export const Head = () => (
  <Seo title={TITLE} description={DESCRIPTION}>
    <title>{TITLE}</title>
  </Seo>
);
const Page = () => (
  <DefaultLayout>
    <YandexMetrika />
    <MailRu />
    <TikTok />
    <VKPixel />
    <AdvCake />

    <main>
      <Screen1 targetGroup={"kids"} />
      <ProblemsWithVideo targetGroup={"kids"}/>
      <Results/>
      <ResultsAndReviewsTop data={resultsAndReviewsKids}/>
      <Tasks targetGroup={"kids"}/>
      <HowWorks
        targetGroup={"kids"}
        accessTimeText={"Доступ к нашей обучающей платформе на 2 года:"}
      />
      <BlocksCourseStructure
        data={blocksDataKids}
        buttonText={"Оставить заявку"}
        buttonClassName={main.mainBtn}
        buttonAction={"anchor"}
      />
      <AboutPeople
        data={methodistsData}
        sectionClassName={main.methodists}
        title={"Над курсом работали:"}
        titleClassName={main.title2}
        bottomText={[<b>И ещё более 90 специалистов разного профиля:</b>, " методистов, педагогов, разработчиков," +
        " специалистов по мультимедиа продакшену, дизайнеров, сценаристов."]}
        bottomTextClassName={main.methodists__bottomText}
      />
      <AboutAdvance/>
      <Founder/>
      <Cost
        title={"Сколько стоит курс «Учись Учиться 5–7 класс»"}
        widgetOtlichnik={<GetCourseWidget hash={'bbffedaa18205bbb44faf2933c8563cee1a88259'} id={'669863'} />}
        widgetIndi={<GetCourseWidget hash={'7149f9f273ed4cb7cdb115607506b063ef3561ac'} id={'669261'} />}
      />
      <VideoReviewsSimple
        data={videoReviews}
        sectionClassName={main.videoReviews__bottom}
        titleClassName={main.title2}
      />
    </main>

    <FooterMedium />
  </DefaultLayout>
);

export default Page;
